import { useEffect, useState } from "react";
import { BasicTable, MASK_MONEY } from "../../../../../../theme/Component/BasicTable";
import { ListMenu } from "../../../../../../theme/Component/ListMenu";
import { PrintJson } from "../../../../../../theme/Component/PrintJson";
import { Modal } from "../../../../../../theme/Component/Modal";
import { InputMoney } from "../../../../../../theme/Input/InputMoney";
import { AccountEditor } from "../../../../../../editor/AccountEditor";
import { SelectAccountantTree } from "../../../../../../contabilidad/catalogo-cuentas/AccountantTree/SelectAccountantTree";
import { SelectBudgetID } from "../../../../../../admin/configuracion/BudgetID/SelectBudgetID";
import { BasicButton } from "../../../../../../theme/Component/BasicButton";
import useDataBean from "../../../../../../../core/services/dataBean/useDataBean";
import { _Fortnight } from "../../../../../../../core/services/dataBean/EntityCatalogVdos";
import { EmployeeBonusEditor } from "../../../../../../Talentohumano/ParametrosTalentoHumano/EmployeeBonus/Editors/EmployeeBonus.Editor";
import { PayrollTypeSelect } from "../../../../../../Talentohumano/ParametrosTalentoHumano/PayrollFactor/PayrollTypeSelect";
import { EmployeePaymentsEditor } from "../../../../../../Talentohumano/ParametrosTalentoHumano/EmployeePayments/EmployyePayment.editor.select";
import { IncapacityLiquidateSelector } from "../../../../../../Talentohumano/ParametrosTalentoHumano/ImportedPayrollConcept/EditorsySelectors/IncapacityLiquidate.Selector";
import { toast } from "react-toastify";
import { FinancialMovementTax } from "../../../../com/quickdataerp/bean/tax/FinancialMovementTax/FinancialMovementTax";
import { SelectEmployeeDiscountType } from "../../../../../../Talentohumano/ParametrosTalentoHumano/EmployeeDiscountType/SelectEmployeeDiscountType";


interface Props {
    idApplicationInvoker: number,
    properties: any;
    data: any;
    setData: any;
    lastStep: boolean;
    cancreate?: boolean
}
export const FortnightDocumentStep = ({ idApplicationInvoker, properties, lastStep, data, setData, cancreate }: Props) => {

    const { instance } = useDataBean(_Fortnight);

    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });
    const [modalAdd, setModalAdd] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-md', type: null });
    const [lista, setLista] = useState<any>([])
    const [bean, setBean] = useState<any>({})
    const [aBean, setABean] = useState<any>({})
    const [originalBean, setOriginalBean] = useState<any>(null);


    useEffect(() => {
        console.log(data)
        if (data.ProductList?.length && data.IDEmployee) {
            setLista(Array.isArray(data.ProductList) ? data.ProductList : []);
        }
    }, [data]);


    const submitForm = () => {
        let key = Object.keys(data);
        console.log({ "ProductList": lista });
        if (setData) {
            setData({ "ProductList": lista });
        }
    }

    const head = [
        { title: 'Nombre', property: 'ProductName', visible: true },
        { title: 'Descripción', property: 'DisplayableText', visible: true },
        { title: 'Valor', property: 'ProductValue', visible: true, mask: MASK_MONEY },
        { title: 'Tercero Débito', property: 'EnjoyerIDName', visible: true },
        { title: 'Tercero Crédito', property: 'BeneficiaryIDName', visible: true },
        { title: 'Cuenta Débito', property: 'DebtAccountantIDStrName', visible: true },
        { title: 'Cuenta Crédito', property: 'CreditAccountantIDStrName', visible: true },
        { title: 'Rubro Presupuestal', property: 'BudgetName', visible: true },
        { title: 'Clase Factor', property: 'ValueClassIDName', visible: true },
        { title: 'Tipo', property: 'FortnightTypeName', visible: true },
    ]

    const listaBotones = () => {
        const botones = [
            {
                titulo: 'Editar',
                icono: 'ri-edit-2-fill',
                visible: true,
                evento: () => {
                    setModal({ ...modal, view: true, name: `Editar ${bean.ProductName}` });
                },
            },
            {
                titulo: 'Eliminar',
                icono: 'ri-delete-bin-6-line',
                visible: cancreate,
                evento: () => {
                    deleteItem(bean);
                },
            },
        ];
        return <ListMenu listaBotones={botones} />;
    };


    const updateList = () => {
        const updatedList = lista.map((item: any) => {
            const itemStr = JSON.stringify(item.DataBeanProperties);
            const originalStr = JSON.stringify(originalBean);

            if (itemStr === originalStr) {
                return {
                    ...item,
                    DataBeanProperties: {
                        ...bean
                    }
                };
            }
            return item;
        });

        setLista(updatedList);

        setModal({ ...modal, view: false });
    };

    const deleteItem = (itemToDelete: any) => {
        const filtered = lista.filter((item: any) => {
            return JSON.stringify(item.DataBeanProperties) !== JSON.stringify(itemToDelete);
        });

        setLista(filtered);
    };

    useEffect(() => {
        if (data.SubType) {
            setIconButtonsItem([
                {
                    nombre: 'Agregar Incapacidad',
                    visible: (cancreate && (data.IDAccount && data.IDPayrollType && data.CostingCenterCode) && (data.SubType === 68)),
                    icono: 'ri-file-add-line',
                    evento: () => {
                        setABean({})
                        setModalAdd({ ...modalAdd, view: true, type: 'incapacity', name: "Agregar Incapacidad" });
                    },
                },
                {
                    nombre: 'Agregar Primas Adicionales / Bonificaciones',
                    visible: (cancreate && (data.IDAccount && data.IDPayrollType && data.CostingCenterCode) && (data.SubType !== 68)),
                    icono: 'ri-file-add-line',
                    evento: () => {
                        setABean({})
                        setModalAdd({ ...modalAdd, view: true, type: 'bonus', name: "Agregar Prima Adicional / Bonificación" });
                    },
                },
                {
                    nombre: 'Agregar Otros Ingresos',
                    visible: (cancreate && (data.IDAccount && data.IDPayrollType && data.CostingCenterCode) && (data.SubType !== 68)),
                    icono: 'ri-file-add-line',
                    evento: () => {
                        setABean({})
                        setModalAdd({ ...modalAdd, view: true, type: 'other', name: "Agregar Otro Ingreso" });
                    },
                },
                {
                    nombre: 'Agregar Descuentos',
                    visible: (cancreate && (data.IDAccount && data.IDPayrollType && data.CostingCenterCode) && (data.SubType !== 68)),
                    icono: 'ri-file-add-line',
                    evento: () => {
                        setABean({})
                        setModalAdd({ ...modalAdd, view: true, type: 'discount', name: "Agregar Descuento" });
                    },
                },
                {
                    nombre: 'Agregar Gravámenes Financieros',
                    visible: (cancreate && (data.IDAccount && data.IDPayrollType && data.CostingCenterCode)),
                    icono: 'ri-file-add-line',
                    evento: () => {
                        setABean({})
                        setModalAdd({ ...modalAdd, view: true, type: 'financial', name: "Agregar Gravámen Financiero" });
                    },
                },
            ])
        } else {
            setIconButtonsItem([
                {
                    nombre: 'Agregar Incapacidad', visible: ((data.IDAccount && data.IDPayrollType && data.CostingCenterCode)), icono: 'ri-file-add-line',
                    evento: () => {
                        setABean({})
                        setModalAdd({ ...modalAdd, view: true, type: 'incapacity', name: "Agregar Incapacidad" });
                    },
                },
                {
                    nombre: 'Agregar Primas Adicionales / Bonificaciones',
                    visible: ((data.IDAccount && data.IDPayrollType && data.CostingCenterCode)),
                    icono: 'ri-file-add-line',
                    evento: () => {
                        setABean({})
                        setModalAdd({ ...modalAdd, view: true, type: 'bonus', name: "Agregar Prima Adicional / Bonificación" });
                    },
                },
                {
                    nombre: 'Agregar Otros Ingresos',
                    visible: ((data.IDAccount && data.IDPayrollType && data.CostingCenterCode)),
                    icono: 'ri-file-add-line',
                    evento: () => {
                        setABean({})
                        setModalAdd({ ...modalAdd, view: true, type: 'other', name: "Agregar Otro Ingreso" });
                    },
                },
                {
                    nombre: 'Agregar Descuentos',
                    visible: ((data.IDAccount && data.IDPayrollType && data.CostingCenterCode)),
                    icono: 'ri-file-add-line',
                    evento: () => {
                        setABean({})
                        setModalAdd({ ...modalAdd, view: true, type: 'discount', name: "Agregar Descuento" });
                    },
                },
                {
                    nombre: 'Agregar Gravámenes Financieros',
                    visible: ((data.IDAccount && data.IDPayrollType && data.CostingCenterCode)),
                    icono: 'ri-file-add-line',
                    evento: () => {
                        setABean({})
                        setModalAdd({ ...modalAdd, view: true, type: 'financial', name: "Agregar Gravámen Financiero" });
                    },
                },
            ])
        }

    }, [data])

    const [iconButtonsItem, setIconButtonsItem] = useState<any>([]);

    const handleAddSubmit = () => {
        if (modalAdd.type === 'bonus') {
            addBonifications();
        } else if (modalAdd.type === 'other') {
            addOtherBonifications();
        } else if (modalAdd.type === 'discount') {
            addDiscounts();
        } else if (modalAdd.type === "incapacity") {
            addIncapacities();
        } else if (modalAdd.type === "financial") {
            addFinancialTaxRow()
        }
    };

    const addIncapacities = () => {
        instance.createIncapacityPaymentForFundRow(aBean.IncapacityType, data.IDAccount, data.IDPayrollType, data.CostingCenterCode, aBean.IncapacityDays, aBean.Value).then(
            (resp) => {
                setLista((prevLista: any[]) => [...prevLista,
                {
                    DataBeanProperties: resp,
                    DataBeanName: 'account.facts.Fortnight'
                }
                ]);
                setModalAdd({ ...modalAdd, view: false });
                setABean({});
            }
        ).catch(err => { console.log(err) })
    }

    const addBonifications = () => {
        instance.createEmployeeBonusRow(aBean.IDEmployeeBonus, data.IDAccount, data.IDPayrollType, data.CostingCenterCode, aBean.Value).then(
            (resp) => {
                setLista((prevLista: any[]) => [...prevLista,
                {
                    DataBeanProperties: resp,
                    DataBeanName: 'account.facts.Fortnight'
                }
                ]);
                setModalAdd({ ...modalAdd, view: false });
                setABean({});
            }
        ).catch(err => { console.log(err) })
    }

    const addOtherBonifications = () => {
        instance.createEmployeePaymentsTypeRow(aBean.IDEmploymentBonus, data.IDAccount, data.IDPayrollType, data.CostingCenterCode, aBean.Value).then(
            (resp) => {
                setLista((prevLista: any[]) => [...prevLista,
                {
                    DataBeanProperties: resp,
                    DataBeanName: 'account.facts.Fortnight'
                }
                ]);
                setABean({});
                setModalAdd({ ...modalAdd, view: false });
            }
        ).catch(err => { console.log(err) })
    }

    const addDiscounts = () => {
        instance.createEmployeeDiscountTypeRow(aBean.IDType, data.IDAccount, data.IDPayrollType, aBean.Value).then(
            (resp) => {
                setLista((prevLista: any[]) => [...prevLista,
                {
                    DataBeanProperties: resp,
                    DataBeanName: 'account.facts.Fortnight'
                }
                ]);
                setModalAdd({ ...modalAdd, view: false });
                setABean({});
            }
        ).catch(err => { console.log(err) })
    }

    const addFinancialTaxRow = () => {
        instance.createFinancialTaxRow(aBean.IDTaxSchemeValue, data.IDAccount, data.IDPayrollType, aBean.Value).then(
            (resp) => {
                setLista((prevLista: any[]) => [...prevLista,
                {
                    DataBeanProperties: resp,
                    DataBeanName: 'account.facts.Fortnight'
                }
                ]);
                setModalAdd({ ...modalAdd, view: false });
                setABean({});
            }
        ).catch(err => { console.log(err) })
    }

    useEffect(() => {
        if (cancreate) {
            setData(lista)
        }
    }, [lista])

    const [missingFields, setMissingFields] = useState<string[]>([]);

    const validateData = () => {
        if (validateForm() > 0) {
            toast.error("Faltan campos obligatorios por completar");
            return;
        } else {
            handleAddSubmit()
        }
    }

    const validateForm = () => {
        let requiredFields = [];

        if (modalAdd.type === "bonus") {
            requiredFields = ["Value", "IDEmployeeBonus"]
        } else if (modalAdd.type === "other") {
            requiredFields = ["Value", "IDEmploymentBonus"]
        } else if (modalAdd.type === "discount") {
            requiredFields = ["Value", "IDType"]
        } else if (modalAdd.type === "incapacity") {
            requiredFields = ["Value", "IncapacityType", "IncapacityDays"]
        } else if (modalAdd.type === "financial") {
            requiredFields = ["Value", "IDTaxSchemeValue"]
        }

        let missing = [];
        for (let field of requiredFields) {
            if (aBean[field] === null || aBean[field] === undefined || aBean[field] === "") {
                missing.push(field);
            }
        }
        setMissingFields(missing);
        return missing.length;
    };

    return (
        <div className="row">
            <div className="col-md-12">
                <BasicTable
                    body={lista}
                    head={head}
                    iconButtons={iconButtonsItem}
                    rowSet={(e) => {
                        setOriginalBean(e);
                        setBean(e);
                    }} listButtons={listaBotones()} />

                {!cancreate &&
                    <div className="col-md-12">
                        <BasicButton icon="ri-send-plane-2-line" clase="primary" eventClick={submitForm}>Guardar</BasicButton>
                    </div>
                }

                <Modal modal={modal} updateModal={setModal} eventModal={() => { updateList() }} >
                    <div className="row">
                        <div className="col-md-12">
                            <label>Nombre</label>
                            <input type="text" className="form-control" value={bean.ProductName} onChange={(e) => { setBean({ ...bean, ProductName: e.target.value }) }} />
                        </div>
                        <div className="col-md-12">
                            <InputMoney _value={bean.ProductValue} onChange={(e) => { setBean({ ...bean, ProductValue: e }) }} _label="Valor" />
                        </div>
                        <div className="col-md-12">
                            <AccountEditor idAccount={bean.EnjoyerID} label="Tercero Débito" onChange={(e) => { setBean({ ...bean, EnjoyerID: e.IDAccount, EnjoyerIDName: `${e.Nit} - ${e.EntityName}` }) }} />
                        </div>
                        <div className="col-md-12">
                            <AccountEditor idAccount={bean.BeneficiaryID} label="Tercero Crédito" onChange={(e) => { setBean({ ...bean, BeneficiaryID: e.IDAccount, BeneficiaryIDName: `${e.Nit} - ${e.EntityName}` }) }} />
                        </div>
                        <div className="col-md-12">
                            <SelectAccountantTree label="Cuenta Débito" jsonCode={bean.DebtAccountantIDStr} onChange={(e) => { setBean({ ...bean, DebtAccountantIDStr: e.JsonCode, DebtAccountantIDStrName: e.Name }) }} />
                        </div>
                        <div className="col-md-12">
                            <SelectAccountantTree label="Cuenta Crédito" jsonCode={bean.CreditAccountantIDStr} onChange={(e) => { setBean({ ...bean, CreditAccountantIDStr: e.JsonCode, CreditAccountantIDStrName: e.Name }) }} />
                        </div>
                        <div className="col-md-12">
                            <SelectBudgetID onChange={(e) => { setBean({ ...bean, BudgetIDStr: e.JsonCode }) }} jsonCode={bean.BudgetIDStr} label="Rubro Presupuestal" />
                        </div>
                    </div>
                </Modal>

                <Modal modal={modalAdd} updateModal={setModalAdd} eventModal={validateData}  >
                    <div className="row">
                        {modalAdd.type == "bonus" &&
                            <div className="col-md-12">
                                <label className={`${missingFields.includes('IDEmployeeBonus') ? 'has-error' : ''}`}>Beneficio Laboral</label>
                                <EmployeeBonusEditor label=" " idSelector={aBean.IDEmployeeBonus} onChange={(e) => { setABean({ ...aBean, "IDEmployeeBonus": e }) }} />
                            </div>
                        }
                        {modalAdd.type === 'other' &&
                            <div className="col-md-12">
                                <label className={`${missingFields.includes('IDEmploymentBonus') ? 'has-error' : ''}`}>Beneficio Laboral</label>
                                <EmployeePaymentsEditor label=" " idSelector={aBean.IDEmploymentBonus} onChange={(e) => { setABean({ ...aBean, "IDEmploymentBonus": e?.IDEmploymentBonus ?? null }) }} />
                            </div>
                        }
                        {modalAdd.type === 'discount' &&
                            <div className="col-md-12">
                                <label className={`${missingFields.includes('IDType') ? 'has-error' : ''}`}>Tipo de Descuento</label>
                                <SelectEmployeeDiscountType label=" " idSelector={aBean.IDType} onChange={(e) => { setABean({ ...aBean, "IDType": e }) }} />
                            </div>
                        }
                        {modalAdd.type === 'incapacity' &&
                            <>
                                <div className="col-md-12">
                                    <label className={`${missingFields.includes('IncapacityType') ? 'has-error' : ''}`}>Tipo de Incapacidad</label>
                                    <IncapacityLiquidateSelector label=" " idSelector={aBean.IncapacityType} onChange={(e) => { setABean({ ...aBean, "IncapacityType": e }) }} />
                                </div>
                                <div className="col-md-12">
                                    <label className={`${missingFields.includes('IncapacityDays') ? 'has-error' : ''}`}>Número de Dias de Incapacidad</label>
                                    <input type="number" className="form-control" value={aBean.IncapacityDays} onChange={(e) => { setABean({ ...aBean, IncapacityDays: Number(e.target.value) }) }} />
                                </div>
                            </>
                        }
                        {modalAdd.type === "financial" &&
                            <div className="col-md-12">
                                <label className={`${missingFields.includes('IDTaxSchemeValue') ? 'has-error' : ''}`}>Gravámen Movimiento Financiero (GMF)</label>
                                <FinancialMovementTax onChange={(e) => { setABean({ ...aBean, IDTaxSchemeValue: Number(e) }) }} label=" " />
                            </div>
                        }
                        <div className="col-md-12">
                            <label className={`${missingFields.includes('Value') ? 'has-error' : ''}`}>Valor</label>
                            <InputMoney _value={aBean.Value} onChange={(e) => { setABean({ ...aBean, Value: e }) }} _label=" " />
                        </div>
                    </div>
                </Modal>
            </div>
        </div>
    )
}